import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=edcb1bb0&scoped=true&"
var script = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=edcb1bb0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edcb1bb0",
  null
  
)

export default component.exports